import { render, staticRenderFns } from "./AccountProjectAssetsNotification.vue?vue&type=template&id=3867e379"
import script from "./AccountProjectAssetsNotification.vue?vue&type=script&lang=js"
export * from "./AccountProjectAssetsNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports